import { Stack, StackProps } from "@mui/material";

interface Props extends StackProps {}

export default function PageTabContent({ children, sx, ...otherProps }: Props) {
  return (
    <Stack
      data-testid='PageTabContent'
      className='AppPageTabContent'
      gap={1.5}
      sx={{
        width: "100%",
        height: "fit-content",
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </Stack>
  );
}
